export default {
  tokenInvalid: 'The access token is invalid',
  placeholderInput: 'Please input',
  placeholderSelect: 'Please select',
  pleaseScan: 'Please scan the ',
  productCode: 'Product Code',
  productName: 'Product Name',
  productSize: 'Size',
  sendStatus: 'Send Status',
  taggingTime: 'Tagging Time',
  taggingDate: 'Tagging Date',
  search: 'Search',
  clear: 'Clear',
  close: 'Close',
  status: 'Status',
  total: 'Total',
  success: 'Operation successful',
  error: 'operation failed',
  errorTitle: 'Error',
  infoTitle: 'Info',
  successTitle: 'Success',
  warningTitle: 'Warning',
  confirmTitle: 'Confirm',
  tagSuccess: 'Tag Success',
  products: 'Products',
  resendFailed: 'resend failed',
  sendTime: 'Send Time',
  sendDate: 'Send Date',
  workStation: 'Workstation',
  operator: 'Operator',
  sendFail: 'Send Fail',
  sendSuccess: 'Send Success',
  sendTotal: 'Total Lines',
  resend: 'Resend',
  download: 'Download',
  isRequired: ' is required',
  delete: 'Delete',
  addNew: 'Add New',
  add: 'Add',
  edit: 'Edit',
  channel: 'Channel',
  plant: 'Plant',
  rfidPlant: 'RFID Plant',
  nfcPlant: 'NFC Plant',
  tagType: 'Tag Type',
  tagTypeDesc: 'Tag Type Desc',
  export: 'Export query results',
  failureList: 'Export Latest Inactive SKU',
  exportAllInactiveSKU: 'Export All Inactive SKU',
  exportLatestActiveSKUList: 'Export Latest Active SKU List',
  disable: 'Disable',
  enable: 'Enable',
  disableMessage: 'do you confirm to disable?',
  error404: 'The page you visited does not exist.',
  errorAuth: 'Sorry!',
  errorTitle1: 'You are not authorized to access this page.',
  errorTitle2: 'Please contact administrator.',
  operation: 'Operation',
  columnsSettingTitle: 'Column Display',
  collapse: 'Collapse',
  expand: 'Expand',
  orderNumber: 'Order Number',
  all: 'Select All',
  upc: 'UPC',
  cartonNo: 'Carton No',
  qrCode: 'QR Code',
  waverunNo: 'Waverun No',
  noDataExport: 'No Data To Export',
  sku: 'SKU',
  placeholderScanInput: 'Please input or scan',
  disableNfc: 'Disable',
  scanComplete: 'Scan Complete',
  backToScanning: 'Back to Scanning',
  rfidEpc: 'RFID EPC',
  shipTo: 'Ship To',
  shipToName: 'Ship To Name',
  lastUpdatedBy: 'Last Updated By',
  lastUpdateTime: 'Last Update Time',
  createTime: 'Created Time',
  updateTime: 'Update Time'
}
